import { NomenclaturePage } from '@/features/bom/pages/nomenclature-page'
import { projectMaterialsQuery } from '@/features/bom/queries/bom-query'
import { nomenclatureTreeQuery } from '@/features/bom/queries/nomenclature-tree-query'
import { sheetSearchSchema } from '@/features/bom/types'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/projects/$projectId/_layout/nomenclature')({
  validateSearch: sheetSearchSchema,
  // Prefetch BOTH the structure tree and the global materials catalog so
  // either tab renders without a Suspense flash, regardless of which one
  // the user lands on (the URL `?tab=` may target either). Both queries
  // are cheap and dedup against any other concurrent reader.
  loader: ({ context: { queryClient }, params }) => {
    const projectId = Number(params.projectId)
    return Promise.all([
      queryClient.ensureQueryData(nomenclatureTreeQuery(projectId)),
      queryClient.ensureQueryData(projectMaterialsQuery(projectId)),
    ])
  },
  staticData: { crumb: messages.crumbs.bom },
  component: NomenclaturePage,
})
